import React, { useState } from "react";
import Rail from "./Rail";
import SideMenu from "./SideMenu";
import "./shell.css";
import Header2 from "../Header2";

type Props = { children: React.ReactNode };

export default function AppShell({ children }: Props) {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <div className="appRoot">
            <Header2 />

            <div className="appBody">
                <Rail collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
                {!collapsed && <SideMenu />}

                <div className="workspace">
                    <div className="workspaceBody">{children}</div>
                </div>
            </div>
        </div>
    );
}